import { Popover } from "react-aria-components";
import React, { ComponentProps } from "react";
import clsx from "clsx";

import styles from "./dropdown-popover.module.css";

interface DropdownPopover {
  children: React.ReactNode;
  className?: string;
  placement?: ComponentProps<typeof Popover>["placement"];
}

export default function DropdownPopover({
  children,
  className,
  placement = "bottom left",
}: DropdownPopover) {
  return (
    <Popover className={clsx(styles.popOver, className)} placement={placement}>
      {children}
    </Popover>
  );
}
